<h4 mat-dialog-title>
  <span *ngIf="!data?.id; else editHeader">
    Creazione nuova disposizione
  </span>
  <ng-template #editHeader>
    Modifica disposizione {{ data?.titolo }}
  </ng-template>
</h4>
<form *ngIf="form" [formGroup]="form" class="mt-2" (keydown.enter)="edit()">
  <mat-form-field appearance="fill">
    <mat-label>Gruppo</mat-label>
    <gruppo-picker formControlName="gruppo"></gruppo-picker>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Titolo</mat-label>
    <input matInput formControlName="titolo" />
  </mat-form-field>

  <mat-form-field appearance="fill" class="no-bottom-padding">
    <mat-label>Contenuto</mat-label>
    <textarea matInput rows="6" formControlName="contenuto"></textarea>
  </mat-form-field>

  <div class="file-upload-section" *ngIf="isNew">
    <button mat-stroked-button type="button" (click)="fileInput.click()">
      <mat-icon>attach_file</mat-icon> Aggiungi allegati
    </button>
    <input #fileInput type="file" hidden multiple (change)="onFilesSelected($event)" />
    <div *ngIf="files.length" class="file-list">
      <div *ngFor="let file of files; let i = index" class="file-item">
        <mat-icon>insert_drive_file</mat-icon>
        <span class="file-name">{{ file.name }}</span>
        <button mat-icon-button type="button" (click)="removeFile(i)">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </div>
</form>
<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="dialogRef.close()">Annulla</button>
  <button mat-flat-button color="primary" (click)="edit()" [disabled]="form.invalid">Salva</button>
</mat-dialog-actions>
